import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  input: {
    padding: '10px 12px',
    cursor: 'pointer',
  },
}));
